// Helper to persist & detect SDK iframe mode (app_type=skor-sdk)
// Single source of truth – use this everywhere instead of ad-hoc localStorage checks.

const SDK_KEY = "skor-sdk";
const STORAGE_KEY = "app_type";

export const getAppTypeFromSearch = (search = window.location.search) => {
  try {
    const params = new URLSearchParams(search);
    return params.get("app_type") || params.get("appType") || null;
  } catch {
    return null;
  }
};

export const isSkorSdkSearch = (search = window.location.search) =>
  getAppTypeFromSearch(search) === SDK_KEY;

export const isSkorSdkMode = (search) => {
  if (typeof window === "undefined") return false;
  const activeSearch =
    typeof search === "string" ? search : window.location.search;
  if (isSkorSdkSearch(activeSearch)) return true;
  return localStorage.getItem(STORAGE_KEY) === SDK_KEY;
};

// Persist SDK flag from current URL → localStorage. Call on every navigation.
export const persistSkorSdkFromUrl = (search = window.location.search) => {
  if (isSkorSdkSearch(search)) {
    localStorage.setItem(STORAGE_KEY, SDK_KEY);
    return true;
  }
  return false;
};

export const clearSkorSdkMode = () => {
  localStorage.removeItem(STORAGE_KEY);
};
